import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import Modal from '@/common/components/Modal';

interface CreateColumnModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (title: string) => void;
}

export const CreateColumnModal = ({ isOpen, onClose, onSubmit }: CreateColumnModalProps) => {
  const { t } = useTranslation();
  const [title, setTitle] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (title.trim()) {
      onSubmit(title.trim());
      setTitle('');
      onClose();
    }
  };

  return (
    <Modal isOpen={isOpen} title={t('kanban.createColumn')} onClose={onClose}>
      <div className="flex flex-col gap-4">
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              {t('kanban.columnTitle')}
            </label>
            <input
              className="w-full p-2 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#FFD66B]"
              placeholder={t('kanban.columnTitlePlaceholder')}
              type="text"
              value={title}
              autoFocus
              onChange={(e) => setTitle(e.target.value)}
            />
          </div>
          <div className="flex justify-end gap-2">
            <button
              className="px-4 py-2 text-gray-700 bg-gray-100 rounded-xl hover:bg-gray-200"
              type="button"
              onClick={onClose}
            >
              {t('common.cancel')}
            </button>
            <button
              className="px-4 py-2 text-white bg-gray-900 rounded-xl hover:bg-gray-800"
              disabled={!title.trim()}
              type="submit"
            >
              {t('kanban.create')}
            </button>
          </div>
        </form>
      </div>
    </Modal>
  );
};
